import { NgModule } from '@angular/core';
import { CratesService } from './crates.service';
import { CratesBackend } from './crates.backend';

@NgModule({
  providers: [CratesService, CratesBackend],
})
export class CratesModule {}
